import React, { Fragment } from "react";
import axios from "axios";
import dropboxIcon from "../assets/dropbox_logo_small.png";

const DriveUpload = (props) => {
    const dropBoxOptions = {
        success:function(files)   {
            var fileData = {};
            fileData.name = files[0].name;
            fileData.link = files[0].link;
            fileData.src = "DROPBOX";
            resumeHandler.receiveResume(fileData);
          },
      cancel : function(){
        resumeHandler.userCancel();
      },
      linkType: "direct",
      multiselect: false,
      folderselect: false,
      extensions: ['.pdf', '.doc', '.docx']
      };

      function triggerDropboxUpload() {

          resumeHandler.initResumePicker("Dropbox");
          var button = window.Dropbox.choose(dropBoxOptions);
      }

      var ResumeUploadHandler = function(){
        if( ResumeUploadHandler.inst ) return ResumeUploadHandler.inst;
        if( ! this instanceof ResumeUploadHandler ) return new ResumeUploadHandler();
        ResumeUploadHandler.inst = this;
        var self = this;
        var receivedFileData = null;
        var receivedUserData = null;
        var userInfoArray = ["fname","lname","phone","email"];
        var initiatedFrom = null , textResumeData = null, uploadData = null;
        var wurl = "";

        var initResumePicker = function( startedFrom ){
          initiatedFrom = startedFrom;
        }

        var setUserData = function(data){
          receivedUserData = data;
        }

        var displayReceivedResume = function(){
          var fileDisplayName = "";
          if( receivedFileData && receivedFileData.name ){
            fileDisplayName = receivedFileData.name;
          } else {
            fileDisplayName = ( receivedUserData.fname + " " + receivedUserData.lname ).trim().replace(" ","_")+".pdf";
          }
          var resumeDisplayHtml = fileDisplayName;
          props.updateResumeFileName( resumeDisplayHtml );
        }

        var localFormatPhone = function(phoneVal){
          phoneVal = phoneVal.replace(/[^\d]/g, "");
          if (phoneVal.length === 10) {
            return phoneVal.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
          }
          return phoneVal;
        }

        var displayUserProfile = function(){
          displayReceivedResume();
          props.hideLoad();
          props.onFormSubmit('customForm');
          for( var i = 0; i < userInfoArray.length; i++ ){
            var cur = userInfoArray[i];
            if( receivedUserData && receivedUserData[cur] ){
              var userVal = receivedUserData[cur];
              if( cur === "phone" ){
                userVal = userVal.replace(/[^0-9]/g,'');
              }
            } else {

            }
          }

        }

        var resumeReceiveSuccess = function(data){
          if(data){receivedUserData = data;}
          displayUserProfile();
        }

        var resumeReceiveError = function(){
          userCancel();
        };

        var removeSelectedResume = function(){
          userCancel();
        }

        var userCancel = function(){
          props.hideLoad();
        }

        function resumeAvailabityOption(t){
          var selectedValue = "";
          axios.post(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins.jsp", {
            params: {
              resumeAgents : selectedValue,
              optin_advertisers : selectedValue
            }
          })
          .then(function (response) {

          })
          .catch(function (error) {
            //console.log(error);
            props.hideLoad();
          })
          .then(function () {
            // always executed
          });
        }

        var receiveResume = function(fileData){
          props.showLoad();
          receivedFileData = fileData;
          if(props.hostedType.toLowerCase() === "hosted" || props.hostedType.toLowerCase() === "hosted_plus"){
          axios.all([
            axios.post(process.env['REACT_APP_API_URL'] + "/upward/applicationSubmit.jsp", props.queryString3),
            axios.get(process.env['REACT_APP_API_URL'] + '/upward/includes/downloadCloud.jsp', {
              params: {
                "RESUME_LINK" : receivedFileData.link,
                "FILE_NAME" : receivedFileData.name,
                "resume_source" : receivedFileData.src,
                "attachResume" : true
              },
              headers : {
                  "X-Requested-With" : "XMLHttpRequest"
              }
            })
          ])
          .then(function (response) {
            resumeReceiveSuccess(response);
          })
          .catch(function (error) {
            resumeReceiveError();
            props.hideLoad();
          })
          }else{
            axios.all([
              axios.get(process.env['REACT_APP_API_URL'] + '/upward/includes/downloadCloud.jsp', {
                params: {
                  "RESUME_LINK" : receivedFileData.link,
                  "FILE_NAME" : receivedFileData.name,
                  "resume_source" : receivedFileData.src,
                  "attachResume" : true
                },
                headers : {
                    "X-Requested-With" : "XMLHttpRequest"
                }
              })
            ])
            .then(function (response) {
              resumeReceiveSuccess(response);
            })
            .catch(function (error) {
              resumeReceiveError();
              props.hideLoad();
            })
          }
        }
        function localSetQuery() {
          var domainOut = window.location.hostname;
          domainOut = domainOut.replace("www.","").replace("stage.","");
          var jobInternalPost = "";
          var locationUsed = "";
          var query = {
            "CID": props.cid,
            "SID": props.sid,
            "job": jobInternalPost,
            "location":locationUsed,
            "job_title":jobInternalPost,
            "degree_held":"",
            "counselor":"",
            "graduation_year":"",
            "siteId": props.siteId,
            "domain":domainOut,
            "keyMapId": props.keyMapId,
            "LOOKUP":"homeCarrier",
            "return_url":process.env['REACT_APP_API_URL']+"/upward/resultsRedirect.jsp"
          }
        }
        function localInternalPost(w) {
              var queryOut = localSetQuery();
              if (w === 'signup') {
                wurl = process.env['REACT_APP_API_URL'] + "/upward/accountSignup.jsp?OID=3002";
              } else if (w === 'sms') {
                wurl = process.env['REACT_APP_API_URL'] + '/upward/smsActions.jsp?OID=2984&CID=&SID=&enabled=y&phone=';
              }else if (w === 'post') {
                  wurl = process.env['REACT_APP_API_URL'] + '/search/internalPost2.fsn?OID=3002&CRID=';
              } else {
                  wurl = process.env['REACT_APP_API_URL'] + '/search/internalPost2.fsn?OID='+w+'&CRID=';
              }
          }

        var continueAfterUserSignUp = function(){

          displayReceivedResume();
        }

        var setTextResume = function(data){
          textResumeData = data;
        }

        var setUploadData = function(data){
          uploadData = data;
        }

        var createAccount = function(){
          var obj = {};
          receivedUserData = obj;
          localInternalPost('signup')
                  .always( function(data,textStatus,jqXHR){
                      return localInternalPost('post')
                  })
                  .always( function(data,textStatus,jqXHR){
                      return localInternalPost('sms')
                  })
            .always( function(data,textStatus,jqXHR){
              continueAfterUserSignUp();
            });
        }
        return {
          initResumePicker : initResumePicker,
          receiveResume : receiveResume,
          userCancel : userCancel,
          removeSelectedResume : removeSelectedResume,
          createAccount : createAccount,
          setUserData : setUserData,
          resumeReceiveSuccess : resumeReceiveSuccess,
          setTextResume : setTextResume,
          setUploadData : setUploadData
        }
      }
    var resumeHandler = new ResumeUploadHandler();


    return (
        <Fragment>
            <button id="DropBoxResumeButton" onClick={triggerDropboxUpload} type="button" className="btn btnClear btnBordered resumeSelectButton btnSmall btn-sm dropboxButton"><img src={dropboxIcon} alt="Dropbox" /> Dropbox</button>
            <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
        </Fragment>
    )

}

export default DriveUpload;
